import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import seoDataApi from "../../services/Api/seoData";

export const fetchSeoRegistrations = createAsyncThunk(
  "seoRegistration/fetchSeoRegistrations",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await seoDataApi.getSeoData();
      // data.seo_registration should already be an array
      return data.seo_registration;
    } catch (err) {
      /* prefer the most specific message, but ALWAYS make it a string */
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong";
      return rejectWithValue(message);
    }
  }
);

export const fetchPartnerLead = createAsyncThunk(
  "seoRegistration/fetchPartnerLead",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await seoDataApi.getPartnerLead();
      // data.seo_registration should already be an array
      console.log("data leads", data.data.details);
      return data?.data?.details;
    } catch (err) {
      /* prefer the most specific message, but ALWAYS make it a string */
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong";
      return rejectWithValue(message);
    }
  }
);

const seoRegistrationSlice = createSlice({
  name: "seoRegistration",
  initialState: {
    items: [],
    getLead: [],
    status: "idle",
    isStatus:"idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeoRegistrations.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSeoRegistrations.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchSeoRegistrations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchPartnerLead.pending, (state) => {
        state.isStatus = "loading";
        state.error = null;
      })
      .addCase(fetchPartnerLead.fulfilled, (state, action) => {
        state.isStatus = "succeeded";
        state.getLead = action.payload;
      })
      .addCase(fetchPartnerLead.rejected, (state, action) => {
        state.isStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default seoRegistrationSlice.reducer;
